import { useLocation } from 'react-router-dom';
import { MdOutlineAutoAwesome } from 'react-icons/md';
import { AgentSessionManager } from '@Components/AgentChat';
import { Drawer } from '@Components/Drawer';
import { Agent, useAgentEndpoint } from '@src/utils/agent-endpoints';
import { useExperimentFlag } from '@src/utils/experiment-context';
import { useCompanyInfo } from '@src/utils/hooks/useCompanyInfo';

// Restores the LLM chat that used to appear on this page in bpm-frontend (ported into a floating
// panel there via DEV-19074, gated on the same 'enableLLM' flag + '/cross-channel/' path check).
// That panel called the old generic /llm chat backend; this wires the equivalent tinuiti-frontend
// agent (Agent.DATA_ANALYSIS — the general "ask about your data" agent) into the same Drawer
// AgentDrawer uses for Dashboards/Charts, since no cross-channel-specific agent exists.
export const CrossChannelAgentDrawer = () => {
  const { pathname } = useLocation();
  const agentEndpoint = useAgentEndpoint(Agent.DATA_ANALYSIS);
  const { cid: company } = useCompanyInfo();
  const enableLLM = useExperimentFlag('enableLLM');

  if (!company || !enableLLM || !pathname.includes('/cross-channel/')) return null;

  return (
    <Drawer
      title='Data Analysis Agent'
      toggleIcon={<MdOutlineAutoAwesome />}
      toggleAriaLabel='Ask about your cross-channel data'
      // Stacks above the Help Center button (bottom: 24px, also 34x34) on pages where both appear.
      bottomOffset={70}
    >
      <AgentSessionManager
        agentEndpoint={agentEndpoint}
        agent={Agent.DATA_ANALYSIS}
        company={company}
      />
    </Drawer>
  );
};
